export class ClientModel {

    navigation: ClientNavigationModel;

    constructor() {

        //set up targeted data for this client
        let clientNavigationModel = {
            pages:
                [
                    {
                        pageTitle: 'start',
                        pageTabs: [
                            { tabTitle: 'workroles' },
                            { tabTitle: 'workinghours' },
                            { tabTitle: 'contributions' },
                            { tabTitle: 'investments' },
                            { tabTitle: 'retirementage' }
                        ]
                    },
                    {
                        pageTitle: 'Page2',
                        pageTabs: [
                            { tabTitle: 'Tab1', },
                            { tabTitle: 'Tab2', }
                        ]
                    }
                ]
        };

        this.navigation = new ClientNavigationModel(clientNavigationModel);
    }
}

export class ClientNavigationModel {
    pages: ClientPageModel[];

    constructor(obj: any) {

        this.pages = [];
        if (obj.hasOwnProperty('pages')) {
            for (let item of obj.pages) {
                this.pages.push(new ClientPageModel(item));
            }
        }
    }
}

export class ClientPageModel {
    pageTitle: string;
    pageTabs: ClientPageTabModel[];

    constructor(obj: any) {

        if (obj.hasOwnProperty('pageTitle')) {
            this.pageTitle = obj.pageTitle;
        }

        this.pageTabs = [];
        if (obj.hasOwnProperty('pageTabs')) {
            for (let item of obj.pageTabs) {
                this.pageTabs.push(new ClientPageTabModel(item));
            }
        }
    }
}

export class ClientPageTabModel {
    tabTitle: string;

    constructor(obj: any) {
        if (obj.hasOwnProperty('tabTitle')) {
            this.tabTitle = obj.tabTitle;
        }
    }
}
